import React from 'react';
import styled from 'styled-components';
import WelcomeImage from 'assets/welcome.svg';

const Wrapper = styled.div`
  margin: -16px;
  background: white;
`;

const InfoComponent = () => (
  <Wrapper>
    <img src={WelcomeImage} alt="Welcome" />
  </Wrapper>
);

export default InfoComponent;



// WEBPACK FOOTER //
// ./src/components/InfoComponent/InfoComponent.js